type Notification = {
	level: string;
	audience?: string;
};

export function partitionVisibleNotifications<T extends Notification>(
	notifications: T[],
	permissionLevel?: string,
) {
	const visible = notifications.filter(({ audience }) => {
		if (audience === 'advanced') return permissionLevel === 'advanced';
		if (audience === 'non_advanced') return permissionLevel !== 'advanced';
		return true;
	});

	return {
		advertisements: visible.filter(({ level }) => level === 'advertisement'),
		alerts: visible.filter(({ level }) => level !== 'advertisement'),
	};
}

const SITE_ORIGIN = 'https://algocode.io';

export function isValidAdvertisementLink(link: string) {
	if (!link) return true;
	if (
		Array.from(link).length > 2048 ||
		/[\s\\\u0000-\u001f\u007f-\u009f]/u.test(link)
	)
		return false;
	if (!link.startsWith('/') && !/^https?:\/\//i.test(link)) return false;
	if (link.startsWith('//')) return false;
	try {
		const url = new URL(link, SITE_ORIGIN);
		return (
			['http:', 'https:'].includes(url.protocol) &&
			!url.username &&
			!url.password
		);
	} catch {
		return false;
	}
}

function isCareerOfferDestination(url: URL) {
	return url.origin === SITE_ORIGIN && url.pathname === '/career-offer';
}

export function isCareerOfferBannerHref(href: string) {
	const url = new URL(href, SITE_ORIGIN);
	return isCareerOfferDestination(url);
}

export function buildCareerOfferBannerHref(linkUrl?: string) {
	const link = linkUrl?.trim() || '/career-offer';
	// Guard legacy or malformed API data as well as admin form submissions.
	return isValidAdvertisementLink(link) ? link : '/career-offer';
}
